module.exports = __webpack_public_path__ + "img/servicios.80f3d2c3.png";